module.exports = __webpack_public_path__ + "static/media/france.8b296b78.svg";